/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from '@material-ui/core/styles';
import {TertiaryButton} from '@ion/dls/src/components/buttons/TertiaryButton';
import {dlsTypography, dlsZIndex} from '@ion/dls/src/theme/theme';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the prop definitions for the file Permissions dialog ...
export type FilePermissionsDialogProps = {
  show: boolean;
  title: string;
  message: string;
  actionLabel?: string | JSX.Element;
  zIndex?: number;
  onAction?: () => void;
};

const useStyles = makeStyles<DLSTheme, FilePermissionsDialogProps>(({dls}) => ({
  userForbiddenRoot : {
    zIndex : ({zIndex}) => `${zIndex ?? dlsZIndex('userForbiddenDialogRoot')} !important` as any
  },
  title : {
    ...dlsTypography('h4'),
    padding       : '20px 20px 0px 24px',
    lineHeight    : '24px',
    letterSpacing : 1
  },
  content : {
    padding : '0 20px !important',
    margin  : '10px 0 15px'
  },
  actions : {
    justifyContent : 'flex-start',
    padding        : '0px 2px 8px !important',
    marginTop      : -6
  }
}));

/**
 * @FilePermissionsDialog
 *
 * Modal renders when user attempts to ADD NEW with lacking necessary file permission.
 */
export const FilePermissionsDialog = (props: FilePermissionsDialogProps) => {
  const {
    show,
    title,
    message,
    actionLabel,
    onAction
  } = props;
  const classes    = useStyles(props);

  if (show) {
    const hasActions = Boolean(onAction);
    return (
      <Dialog open classes={{
        root : classes.userForbiddenRoot
      }}>
        <DialogTitle className={classes.title}>
          {title}
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        {hasActions &&
          <DialogActions className={classes.actions}>
            {onAction &&
              <TertiaryButton style={{padding: 0}} onClick={onAction}>
                {actionLabel}
              </TertiaryButton>}
          </DialogActions>}
      </Dialog>
    );
  }
  return null;
};

export default FilePermissionsDialog;
